import React, { useCallback } from "react"
import { StyledInputWrapper, StyledInput } from "../input-v2/partials"
import { StyledLoader, StyledLoaderList, StyledLoaderCopy, StyledLoaderInput } from "./partials"

export interface LoaderProps {
  form_count?: number
}

export const Loader: React.FC<LoaderProps> = ({ form_count = 7 }) => {
  const [inputHeight, setinputHeight] = React.useState("")

  const input = useCallback((node) => {
    if (node !== null) {
      setinputHeight(node.getBoundingClientRect().height)
      if (typeof window !== "undefined"){
        window.addEventListener("resize", () => {
          setinputHeight(node.getBoundingClientRect().height)
        });
      }
    }
    parseInt(inputHeight)
  }, [])

  return (
    <StyledLoader>

      {/* Get Height of input cmp */}
      <StyledLoaderCopy>
        <StyledInputWrapper>
          <StyledInput>
            <input ref={input} />
          </StyledInput>
        </StyledInputWrapper>
      </StyledLoaderCopy>


      <StyledLoaderList>
        {/* Build list of inputs */}
        {Array(form_count).fill(
          <StyledLoaderInput input_height={inputHeight} />
        )}
      </StyledLoaderList>

    </StyledLoader>
  )
}
